var indexOf = [].indexOf;

angular.module('gym.components').directive('triggerSequenceCondition', function() {
  return {
    restrict: 'EA',
    template: require('templates/components/sequences/triggerSequenceCondition.html.slim'),
    replace: true,
    scope: {
      sequence: '=',
      step: '=',
      isForseeable: '=',
      isFollowable: '=',
      isFloatingFollowable: '=',
      isTask: '=',
      isMembership: '=',
      isWorkout: '=',
      isStyle: '='
    },
    controller: ["$scope", function($scope) {
      var base, checkHours, conditionIndex, conditions, getTriggerTime, isHourlyAdvancedTriggers;
      conditions = $scope.step.sequence_conditions_attributes;
      conditionIndex = _.findIndex(conditions, function(condition) {
        return condition.type === 'TriggerSequenceCondition';
      });
      $scope.condition = $scope.step.sequence_conditions_attributes[conditionIndex];
      getTriggerTime = function() {
        return $scope.condition.trigger_time_before || $scope.condition.trigger_time_after || 0;
      };
      if ($scope.condition) {
        $scope.condition.trigger_time = getTriggerTime();
        (base = $scope.condition).trigger_time_unit || (base.trigger_time_unit = 'days');
        $scope.condition.timeCondition = $scope.condition.trigger_time_after ? 'after' : 'before';
      }
      $scope.getAction = function() {
        if ($scope.isTask || $scope.isMembership || $scope.isWorkout || $scope.isStyle) {
          return 'add';
        }
        if ($scope.isMobileApp || $scope.isProspectStatus) {
          return 'change';
        }
        return 'send';
      };
      isHourlyAdvancedTriggers = function() {
        var ref;
        return ref = $scope.sequence.trigger, indexOf.call($scope.sequence.hourly_advanced_triggers, ref) >= 0;
      };
      $scope.timeUnits = ($scope.isForseeable && !isHourlyAdvancedTriggers()) || $scope.isFloatingFollowable ? ['days'] : ['days', 'hours'];
      $scope.timeConditions = ['after', 'before'];
      $scope.onTimeConditionChanged = function() {
        if ($scope.condition.timeCondition === 'before') {
          $scope.condition.trigger_time_before = $scope.condition.trigger_time_after || 0;
          return $scope.condition.trigger_time_after = 0;
        } else {
          $scope.condition.trigger_time_after = $scope.condition.trigger_time_before || 0;
          return $scope.condition.trigger_time_before = 0;
        }
      };
      $scope.onTriggerTimeChanged = function() {
        if ($scope.condition.timeCondition === 'before') {
          return $scope.condition.trigger_time_before = $scope.condition.trigger_time;
        } else {
          return $scope.condition.trigger_time_after = $scope.condition.trigger_time;
        }
      };
      checkHours = function() {
        if (!$scope.condition.immediate && $scope.condition.trigger_time_unit === 'hours') {
          return $scope.condition.allowed_hours = [];
        }
      };
      $scope.onImmediateChanged = function() {
        $scope.condition.trigger_time = 0;
        $scope.condition.trigger_time_after = 0;
        $scope.condition.trigger_time_before = 0;
        return checkHours();
      };
      return $scope.onTimeUnitChange = function() {
        return checkHours();
      };
    }]
  };
});
